import { createI18n } from 'vue-i18n'
import zh from './locales/zh'
import en from './locales/en'
import es from './locales/es'
import { storageUtils } from './utils/storage'

const i18n = createI18n({
  legacy: false,
  locale: storageUtils.getLanguage(),
  fallbackLocale: 'es',
  messages: {
    zh,
    en,
    es
  }
})

export default i18n
